<template>
    <div class="guess-city">
        <h2 class="guess-city__title">{{ messages.yourCity }} {{ userCity.UF_NAME }}?</h2>
        <div class="guess-city__buttons">
            <DefButtonPrimary @click="$DefModal.hide">
                {{ messages.yes }}
            </DefButtonPrimary>
            <DefButtonSecondary @click="handlerChoiceAnotherCity">
                {{ messages.otherCity }}
            </DefButtonSecondary>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import DefButtonPrimary from "../def/DefButtonPrimary/DefButtonPrimary";
import DefButtonSecondary from "../def/DefButtonSecondary/DefButtonSecondary";

export default {
    name: 'guess-city',
    props: ['result'],
    components: {
        DefButtonPrimary,
        DefButtonSecondary,
    },
    computed: {
        ...mapState({
            messages: ({ cities }) => cities.data.messages,
            userCity: ({ cities }) => cities.data.userCity,
        })
    },
    methods: {
        handlerChoiceAnotherCity() {
            this.$DefModal.show({
                name: 'choice-city',
                width: '340px',
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.guess-city{
    //padding: 40px 16px;
    //@include point-md{
    //    padding: 46px 32px;
    //}
    &__buttons{
        display: grid;
        grid-template-columns: minmax(0, 1fr);
        grid-gap: 8px;
        @include point-md{
            grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        }
    }
    &__title{
        font-weight: 500;
        font-size: rem(16);
        line-height: 125%;
        margin-bottom: 24px;
    }
}
</style>